import { useState } from 'react';
import Layout from '@/components/feature/Layout';

export default function ReclamosPage() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <Layout>
      <div className="bg-primary-900 py-16 md:py-24">
        <div className="w-full px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-400 mb-3">
            Atención
          </span>
          <h1 className="font-heading font-bold text-3xl md:text-5xl text-white mb-4">
            Reclamos y Sugerencias
          </h1>
          <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto">
            Tu opinión es importante para mejorar nuestro servicio. Envíanos tu reclamo o sugerencia.
          </p>
        </div>
      </div>

      <div className="w-full px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="max-w-2xl mx-auto">
          {submitted ? (
            <div className="p-8 rounded-xl bg-green-50 border border-green-200 text-center animate-slide-up">
              <div className="w-14 h-14 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-check-line text-green-600 w-7 h-7 flex items-center justify-center"></i>
              </div>
              <h2 className="font-heading font-semibold text-xl text-foreground-950 mb-2">Reclamo Enviado</h2>
              <p className="text-sm text-foreground-600 mb-5">Gracias por tu feedback. Te contactaremos en un plazo de 48 horas hábiles.</p>
              <button
                onClick={() => setSubmitted(false)}
                className="px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-colors text-sm"
              >
                Enviar otro reclamo
              </button>
            </div>
          ) : (
            <div className="p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70">
              <h2 className="font-heading font-semibold text-lg text-foreground-950 mb-6">
                Formulario de Reclamo
              </h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-1.5">Nombre completo</label>
                    <input
                      type="text"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400/50 focus:border-primary-400 transition-all"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-1.5">Código de usuario</label>
                    <input
                      type="text"
                      name="user_code"
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400/50 focus:border-primary-400 transition-all"
                      placeholder="Opcional"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-1.5">Teléfono</label>
                    <input
                      type="tel"
                      name="phone"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400/50 focus:border-primary-400 transition-all"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-1.5">Email</label>
                    <input
                      type="email"
                      name="email"
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400/50 focus:border-primary-400 transition-all"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">Tipo de reclamo</label>
                  <select
                    name="tipo"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400/50 focus:border-primary-400 transition-all"
                  >
                    <option value="">Selecciona...</option>
                    <option value="falta_agua">Falta de agua</option>
                    <option value="baja_presion">Baja presión de agua</option>
                    <option value="fuga">Fuga en red/tubería</option>
                    <option value="medidor">Problema con medidor</option>
                    <option value="facturacion">Facturación incorrecta</option>
                    <option value="atencion">Mala atención</option>
                    <option value="otro">Otro</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">Descripción del reclamo</label>
                  <textarea
                    name="description"
                    required
                    rows={5}
                    maxLength={500}
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400/50 focus:border-primary-400 transition-all resize-none"
                    placeholder="Describe detalladamente tu reclamo..."
                  />
                  <p className="text-xs text-foreground-500 mt-1">Máximo 500 caracteres</p>
                </div>
                {/* Honeypot */}
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="hp-field"
                />
                <button
                  type="submit"
                  className="w-full px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-colors text-sm"
                >
                  Enviar Reclamo
                </button>
              </form>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}